/**
 * Standalone translation function for use OUTSIDE React components
 * (e.g., in Zustand stores). Reads locale from localStorage.
 */
import { de, type TranslationKey } from "./de.js";
import { en } from "./en.js";
import type { Locale } from "./index.js";

const TRANSLATIONS: Record<Locale, Record<string, string>> = { de, en };
const STORAGE_KEY = "solitaire-locale";

function getLocale(): Locale {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "de" || stored === "en") return stored;
  } catch { /* ignore */ }
  return "de";
}

export function translate(key: TranslationKey, params?: Record<string, string | number>): string {
  const locale = getLocale();
  let str = TRANSLATIONS[locale]?.[key] ?? TRANSLATIONS.de[key] ?? key;
  if (params) {
    str = str.replace(/\{\{(\w+)\}\}/g, (_, k) => {
      const val = params[k];
      return val !== undefined ? String(val) : `{{${k}}}`;
    });
  }
  return str;
}
